import React from "react";

export default function ProjectTab({ formData, onChange, disabled }) {
  return (
    <div className="role-tab">
      {/* Enable Project Management */}
      <div className="role-tab__header">
        <h3 className="role-tab__title">Project Management Configuration</h3>
        <label className="role-form__checkbox-label role-form__checkbox-label--large">
          <input
            type="checkbox"
            checked={formData.enableProjectManagement}
            onChange={(e) =>
              onChange("enableProjectManagement", e.target.checked)
            }
            disabled={disabled}
          />
          <span>Enable Project Management</span>
        </label>
      </div>

      {formData.enableProjectManagement && (
        <div className="role-tab__content">
          {/* Allow Field Logs */}
          <label className="role-form__checkbox-label">
            <input
              type="checkbox"
              checked={formData.allowFieldLogs}
              onChange={(e) => onChange("allowFieldLogs", e.target.checked)}
              disabled={disabled}
            />
            <span>Allow Field Logs</span>
          </label>
        </div>
      )}
    </div>
  );
}
